// @flow

import React from 'react';
export function ArchiveIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.5 3C3.67157 3 3 3.67157 3 4.5V6H17V4.5C17 3.67157 16.3284 3 15.5 3H4.5Z"
        fill="#5C5F62"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 15.5C4 16.3284 4.67157 17 5.5 17H14.5C15.3284 17 16 16.3284 16 15.5V8H4V15.5ZM7 11H13V13H7V11Z"
        fill="#5C5F62"
      />
    </svg>
  );
}
